/**
 * Processa templates com variáveis no formato {{chave}}
 * @param {string} template - Texto com variáveis
 * @param {Array} configs - Lista de configurações disponíveis
 * @returns {object} { processed: valor processado, variables: array de variáveis usadas, errors: array de erros }
 */
export const processTemplate = (template, configs = []) => {
  const regex = /\{\{([a-zA-Z_][a-zA-Z0-9_]*)\}\}/g;
  const variables = [];
  const errors = [];
  let processed = template;

  const configMap = {};
  configs.forEach(c => {
    configMap[c.key] = c.value;
  });

  let match;
  while ((match = regex.exec(template)) !== null) {
    const varName = match[1];
    variables.push(varName);

    if (!configMap[varName]) {
      errors.push(`Variável "${varName}" não encontrada`);
    } else {
      processed = processed.replace(`{{${varName}}}`, configMap[varName]);
    }
  }

  return {
    processed,
    variables: [...new Set(variables)],
    errors,
  };
};

/**
 * Encontra todas as variáveis em um template
 * @param {string} template - Texto com variáveis
 * @returns {Array} Array de nomes de variáveis
 */
export const extractVariables = (template) => {
  const regex = /\{\{([a-zA-Z_][a-zA-Z0-9_]*)\}\}/g;
  const variables = [];
  let match;

  while ((match = regex.exec(template)) !== null) {
    variables.push(match[1]);
  }

  return [...new Set(variables)];
};

/**
 * Detecta referências circulares em configurações
 * @param {Array} configs - Lista de configurações
 * @returns {Array} Array com pares [chave1, chave2] que têm referência circular
 */
export const detectCircularReferences = (configs) => {
  const circularRefs = [];

  configs.forEach(config => {
    const variables = extractVariables(config.value);

    variables.forEach(varName => {
      const varConfig = configs.find(c => c.key === varName);
      if (varConfig) {
        const varVariables = extractVariables(varConfig.value);
        if (varVariables.includes(config.key)) {
          circularRefs.push([config.key, varName]);
        }
      }
    });
  });

  return circularRefs;
};
